import * as React from 'react';
import { ReactNode } from 'react';
import { GroupLineItemUI, LineItemUI } from './LineItemUI';

export interface ISummaryUIProps {
    advertisedPriceLabel?: string;
    amountFinanced: string;
    annualMiles: number;
    apr: string;
    aprNotAvailableText: string;
    children?: ReactNode;
    downPayment: string;
    downPaymentText: string;
    dueAtSigningNegativeTradeIn: string;
    dueAtSigningText: string;
    financeDownPayment: string;
    financeNegativeTradeIn: string;
    listedPrice: string;
    notAvailableText: string;
    offerPrice: string;
    offerTypeLabel: string;
    positiveTradeIn: string;
    retailPrice: string;
    specials: string;
    specialsLabel?: string;
    termMonths: string;
    termNotAvailableText: string;
    totalDueAtSigning: string;
    tradeIn: string;
    vehicleType: string;
}

const SummaryUI: React.ComponentType<ISummaryUIProps> = (props) => {
    const {
        advertisedPriceLabel,
        amountFinanced,
        annualMiles,
        apr,
        aprNotAvailableText,
        children,
        downPayment,
        downPaymentText,
        dueAtSigningNegativeTradeIn,
        dueAtSigningText,
        financeDownPayment,
        financeNegativeTradeIn,
        listedPrice,
        notAvailableText,
        offerPrice,
        positiveTradeIn,
        retailPrice,
        specials,
        specialsLabel,
        termMonths,
        termNotAvailableText,
        totalDueAtSigning,
        vehicleType
    } = props;

    return (
        <div className="dr-ui-summary-container">
            <div className="first-column">
                <LineItemUI label="MSRP" value={retailPrice} id="msrp" />
                <LineItemUI label={advertisedPriceLabel} value={listedPrice} id="advertisedPrice" />
                <hr />
                <LineItemUI label="My Price" value={offerPrice} id="offerPrice" />
                {vehicleType !== 'new' && (
                    <LineItemUI label={specialsLabel} value={specials} notAvailableText={notAvailableText} id="specials" />
                )}
                <LineItemUI label="Trade-In Equity" value={positiveTradeIn} id="tradeAllowance" />
                <LineItemUI label="Trade-In Equity" value={financeNegativeTradeIn} id="tradeAllowanceNegative" />
                <LineItemUI label={downPaymentText} value={financeDownPayment} id="downPaymentNegative" />
                <LineItemUI label="Taxes and Fees" value="Not Included" id="taxesAndFees" />
                <GroupLineItemUI
                    label="Total Financed"
                    value={amountFinanced}
                    notAvailableText={notAvailableText}
                    id="amountFinanced"
                />
                <hr />
            </div>
            <div className="second-column">
                <LineItemUI label={downPaymentText} value={downPayment} id="downPayment" />
                <LineItemUI label="Trade-In Equity" value={dueAtSigningNegativeTradeIn} id="tradeAllowance" />
                <GroupLineItemUI label={dueAtSigningText} value={totalDueAtSigning} id="dueAtSigning" />
                <GroupLineItemUI label="Term" value={termMonths} notAvailableText={termNotAvailableText} id="term" />
                <GroupLineItemUI label="APR" value={apr} notAvailableText={aprNotAvailableText} id="apr" />
                <GroupLineItemUI label="Annual Miles" value={String(annualMiles)} id="annualMiles" />
                {children}
            </div>
        </div>
    );
};

export default SummaryUI;
